<template lang="html">
    <div class="container">

        <div class="row">
            <div class="input-field col s12">

                <label for="searchUser">Rechercher un utilisateur</label>
                <input type="text" name="searchUser" v-model="searchTerm">
            </div>
        </div>
        <div class="row">
            <div class="col s12">
                <table class="responsive-table highlight">
                    <thead>
                        <tr>
                            <th>Statut</th>
                            <th>Nom d'utilisateur</th>
                            <th>Nom</th>
                            <th>Prénom</th>
                            <th>Service</th>
                            <th>Email</th>
                            <th>Téléphone</th>
                            <!-- <th>Mobile</th> -->
                            <th>Editer</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in filteredUsers">
 <!-- <code>{{user}}</code> -->
                            <td>
                                <i v-if="(user.active)"class="material-icons center-align green-text">check_circle</i>
                                <i v-else class="material-icons center-align red-text">block</i>
                            </td>
                            <td>{{user.alias}}</td>
                            <td>{{user.last_name}}</td>
                            <td>{{user.first_name}}</td>
                            <td>{{user.service}}</td>
                            <td>{{user.email}}</td>
                            <td>{{user.phone}}</td>
                            <!-- <td>{{user.mobile}}</td> -->
                            <td>
                                <router-link :to="{ name: 'EditUser', params: {user_slug: user.slug} }">
                                    <i class="material-icons">edit</i>
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import db from '@/firebase/init'

export default {
    name: "EditUsers",
    data () {
        return {
            users : [],
            searchTerm: ''
        }
    },
    methods:{
  
    },
    created(){
        //fetch data from firestore
        db.collection('users').orderBy("alias").get()
        .then(snapshot => {
            snapshot.forEach(doc =>{
                let user = doc.data()
                user.id = doc.id
                this.users.push(user)
            })
        })
    },
    computed: {
        //TODO improve filter
            filteredUsers(){
                return this.users.filter(user => {
                    return user.alias.match(this.searchTerm)
                    || user.last_name.match(this.searchTerm)
                    || user.first_name.match(this.searchTerm)
                    || user.service.match(this.searchTerm)
                    || user.email.match(this.searchTerm)
                })
            }
    }
}
</script>

<style lang="css" scoped>

</style>
